import { HorizontalScrollView } from "@clipboard-health/ui-components";
import { Box, Skeleton, Stack } from "@mui/material";

export function LoadingPage() {
  return (
    <Stack
      direction="column"
      gap={4}
      sx={(theme) => ({
        backgroundColor: theme.palette.background.tertiary,
        overflow: "auto",
        position: "relative",
        minHeight: "100vh",
        paddingBottom: 4,
      })}
    >
      {/* Header Skeleton */}
      <Stack direction="column" alignItems="center" gap={4} sx={{ padding: 8 }}>
        <Stack direction="column" alignItems="center" gap={8}>
          <Box />
          <Skeleton variant="circular" width={80} height={80} />
          <Stack direction="column" alignItems="center" gap={2}>
            <Skeleton variant="text" width={220} height={40} />
            <Skeleton variant="rounded" width={100} height={28} />
          </Stack>
        </Stack>
        <Stack direction="column" alignItems="center" gap={7}>
          <Skeleton variant="text" width={300} height={28} />
          <Skeleton variant="rounded" width={120} height={36} />
        </Stack>
      </Stack>

      {/* Perks Section Skeleton */}
      <Box sx={{ margin: 4 }}>
        <Stack direction="column" gap={4}>
          <Skeleton variant="text" width={240} height={36} />
          <HorizontalScrollView stretch sx={{ height: "max-content" }}>
            {[0, 1, 2].map((index) => (
              <Box
                key={index}
                sx={{
                  minWidth: 320,
                  maxWidth: 340,
                  marginRight: 3,
                  padding: 4,
                  border: (theme) => `1px solid ${theme.palette.divider}`,
                  borderRadius: 5,
                  background: (theme) => theme.palette.background.paper,
                }}
              >
                <Stack direction="column" gap={5}>
                  <Stack direction="column" gap={5}>
                    <Stack direction="row" alignItems="center" gap={4}>
                      <Skeleton variant="circular" width={48} height={48} />
                      <Skeleton variant="text" width={120} height={32} />
                    </Stack>
                    <Skeleton variant="text" width={180} height={24} />
                  </Stack>
                  {/* Perk skeletons */}
                  {[0, 1].map((index) => (
                    <Stack key={index} direction="column" gap={2}>
                      <Stack direction="row" alignItems="center" gap={1}>
                        <Skeleton variant="rectangular" width={32} height={32} />
                        <Stack direction="column" gap={1}>
                          <Skeleton variant="text" width={100} height={20} />
                          <Skeleton variant="text" width={180} height={20} />
                        </Stack>
                      </Stack>
                      {index === 0 && <Skeleton variant="rectangular" width={220} height={2} />}
                    </Stack>
                  ))}
                </Stack>
              </Box>
            ))}
          </HorizontalScrollView>
        </Stack>
      </Box>
    </Stack>
  );
}
